module.exports = __webpack_public_path__ + "img/工程机械行业数字化转型场景图谱.4dbc279d.jpg";